/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {CalendarTasksGroup} from '../calendar-tasks-group';

export interface CalendarSelection {

  getResource(): CalendarTasksGroup;

  getStart(): Date;

  getEnd(): Date;

  getEvent(): MouseEvent;

  getPosition(): {x: number, y: number};

  setResource(resource: CalendarTasksGroup);

}
